module.exports = __webpack_public_path__ + "static/media/IE.9420f062.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IE.svg
// module id = 275
// module chunks = 0